























































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import {readBook} from '@/store/courses/getters';
import {dispatchGetBook} from '@/store/courses/actions';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import CourseCard from '../../../components/vui-luma/Course/CourseCard.vue';
import PageHeadline from '../../../components/vui-luma/Ui/PageHeadline.vue';
import CustomSelectInput from '../../../components/vui-luma/Ui/CustomSelectInput.vue';
// @ts-ignore
import logo from '@/assets/images/logo.png';
import pdf from 'vue-pdf';

@Component({
  components: {
      CustomSelectInput,
      CourseCard,
      PageSeparator,
      PageHeadline,
      pdf,
  },
})
export default class Navigator extends Vue {
  public containerClass = 'container page__container';
  public prevControl = false;
  public commentBody = '';
  public currentPage = 1;
  public pageCount = 0;
  public logo = logo;

  public async mounted() {
    await dispatchGetBook(this.$store, {id: this.$router.currentRoute.params.id});
    if (!this.book) {
      this.$router.push('/books');
    }
  }

  get book() {
    return readBook(this.$store);
  }

}
